// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2wDdl","title":"Info_title__2i3rz","selects":"Info_selects__XRvTf","requiredAsterisk":"Info_requiredAsterisk__DEBHw"};